export const isValidNorwegianPnr = (pnr: string) => {
  // Must be length 11
  if (pnr?.length !== 11) return false;

  // Must contain only numbers
  const numericRegex = /^\d+$/;
  if (!numericRegex.test(pnr)) return false;

  // First two digits must be valid date/day
  const day = parseInt(pnr.substring(0, 2), 10);
  if (day < 1 || day > 31) return false;

  return true;
};
